import React from 'react';
import {
  Box, Typography, InputField, NestedForm,
} from 'vindi-ds-components';
import templatePricing from '@pages/product/templates/template_pricing';
import { inputStyles } from '../styles';

function PriceRangeInput({ type }) {
  return (
    <NestedForm name='pricing_schema_attributes.pricing_ranges_attributes'>
      <Box css={inputStyles}>
        <InputField style={{ minWidth: '3.5em', width: '3.5em' }} type='number' name='start_quantity' label={templatePricing[type].start} placeholder='UN' />
        <InputField style={{ minWidth: '3.5em', width: '3.5em' }} type='number' label={templatePricing[type].end} name='end_quantity' placeholder='UN' />
        <Box textAlign='center'>
          <MiddleFieldTitle title={templatePricing[type].factor} />
        </Box>
        <InputField type='number' name='price' label='Preço' placeholder='R$' style={{ minWidth: '3.5em', width: '3.5em' }} />
        <InputField style={{ minWidth: '3.5em', width: '3.5em' }} type='number' name='overage_price' label='Excedentes' placeholder='R$' />
      </Box>
    </NestedForm>
  );
}

const MiddleFieldTitle = ({ title }) => (
  <Typography variant='caption' component='h4'>{title}</Typography>
);

export default PriceRangeInput;
